import React, { useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  Drawer,
  DropdownMenu,
  FormFieldSet,
  HoverPopup,
  LogoLoader,
  NewTab,
  NewTableAdv,
  PageTab,
  showToast,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import Comments from "./Chat/Comments";
import DraftChat from "./Chat/DraftChat";
import InitiatedChat from "./Chat/InitiatedChat";
import RespondedChat from "./Chat/RespondedChat";
import { useEffect } from "react";
import {
  fetchOnboardings,
  updateOnboarding,
} from "../../../../redux/slices/onboarding/onboardingApi";
import {
  documentOnboardingStatus,
  onboardingStatus,
} from "../../../../assets/data/enumData";
import { usePagination } from "../../../../hooks";
import DashboardDrawer from "./ModalsAndDrawers/DashboardDrawer";
import JoinOnboardingDrawer from "./ModalsAndDrawers/JoinOnboardingDrawer";
import { Link } from "react-router-dom";
import { debounce } from "lodash";
import { useMemo } from "react";
import { useCallback } from "react";
import { fieldsToDroppedFieldsMapper } from "../../../../utils/wf/onboarding.helpers";

const tableData = [
  { uiid: 1, name: "Sajida", jobTitle: "Video Editor", status: "Joined" },
  { uiid: 2, name: "Mahesh", jobTitle: "Video Editor", status: "Draft" },
  { uiid: 3, name: "Ajay", jobTitle: "Video Editor", status: "Initiated" },
  { uiid: 4, name: "Kranthi", jobTitle: "Video Editor", status: "Responded" },
  { uiid: 5, name: "Ramesh", jobTitle: "Video Editor", status: "Verified" },
  { uiid: 6, name: "Sajida", jobTitle: "Video Editor", status: "Rejected" },
  { uiid: 7, name: "Mahesh", jobTitle: "Video Editor", status: "Negotiate" },
  { uiid: 8, name: "Ajay", jobTitle: "Video Editor", status: "Joined" },
  {
    uiid: 9,
    name: "Kranthi",
    jobTitle: "Video Editor",
    status: "Disqualified",
  },
  { uiid: 10, name: "Ramesh", jobTitle: "Video Editor", status: "Cancelled" },
];

const statusStyles = {
  Pending: `bg-blue-100 text-linkblue px-4 py-2`,
  Joined: `bg-success-50 text-success px-4 py-2`,
  Draft: `bg-warning-100 text-warning px-4 py-2`,
  Initiated: `bg-warning-100 text-warning px-4 py-2`,
  Responded: `bg-warning-100 text-warning px-4 py-2`,
  Verified: `bg-success-50 text-success px-4 py-2`,
  Rejected: `bg-danger-50 text-danger px-4 py-2`,
  Negotiate: `bg-warning-100 text-warning px-4 py-2`,
  Disqualified: `bg-success-50 text-success px-4 py-2`,
  Cancelled: `bg-danger-50 text-danger px-4 py-2`,
};

// const dropdownMenuButtons = [
//   { label: "Join Onboarding", onClick: () => {} },
//   { label: "Cancel Onboarding", onClick: () => {} },
//   { label: "Verify Onboarding", onClick: () => {} },
//   { label: "Disqualify Onboarding", onClick: () => {} },
//   { label: "Applicant Portals", onClick: () => {} },
//   { label: "Copy Applicant Portals URL", onClick: () => {} },
//   { label: "Send Reminder", onClick: () => {} },
//   { label: "Send Portal Details", onClick: () => {} },
//   { label: "Lock Applicant Portal", onClick: () => {} },
//   { label: "Change Applicant Password", onClick: () => {} },
//   { label: "Add Void Document", onClick: () => {} },
// ];

const AllDashboard = ({
  statusFilter,
  pageName,
  onDropdownClick,
  entityFilter,
}) => {
  const updateStatus = async (id, data, label) => {
    try {
      if (!id || !data) {
        showToast("Coming Soon");
        return;
      }
      showToast(`${label} ${id}`);
      await updateOnboarding({
        coll: "Onboarding",
        uiid: id,
        payload: [
          {
            type: "SET",
            value: {
              ...data,
            },
          },
        ],
      });
      fetchOnboardingsTable(page, limit);
    } catch (error) {
      console.error("Error in updateOnboarding", error);
      showToast("Something Went Wrong");
    }
  };
  const [dropdownMenuButtons, setDropdownMenuButtons] = useState([
    {
      label: "Join Onboarding",
      onClick: () => setIsJoinOnboardingDrawerOpen(true),
    },
    // { label: "Cancel Onboarding", onClick: () => {} },
    // { label: "Verify Onboarding", onClick: () => {} },
    // { label: "Disqualify Onboarding", onClick: () => {} },
    // { label: "Applicant Portals", onClick: () => {} },
    // { label: "Copy Applicant Portals URL", onClick: () => {} },
    // { label: "Send Reminder", onClick: () => {} },
    // { label: "Send Portal Details", onClick: () => {} },
    // { label: "Lock Applicant Portal", onClick: () => {} },
    // { label: "Change Applicant Password", onClick: () => {} },
    // { label: "Add Void Document", onClick: () => {} },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { page, limit, setPage, setLimit, handleLimitChange } =
    usePagination(25);
  const [select, setSelect] = useState("");
  const [isChatOPen, setIsChatOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isJoinOnboardingDrawerOpen, setIsJoinOnboardingDrawerOpen] =
    useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [selectedDocument, setSelectedDocument] = useState({});
  const [onboardingData, setOnboardingData] = useState({
    data: [],
    totalCount: 0,
  });

  useEffect(() => {
    setPage(1);
    setLimit(25);
  }, [statusFilter, pageName]);

  const openChecklistDrawer = (onboarding, id, type) => {
    try {
      //if multiple checklists added this api structure will change
      const infoData = {
        employeeInfo: {
          name:
            (onboarding?.entity?.id?.firstName || "") +
            " " +
            (onboarding?.entity?.id?.lastName || ""),
          email: onboarding?.entity?.id?.email?.primary || "-",
        },
        doj: onboarding?.doj ? dateFormator(onboarding?.doj) : "-",
        checkListName: onboarding?.checklists?.[0]?.id?.name || "-",
        cardsData:
          onboarding?.checklists?.[0]?.documents?.map((data, i) => {
            const mappedFields = fieldsToDroppedFieldsMapper(data?.fields,data?.id?.fields)

            const normalizedMetaData = {
              ...data,
              id: {
                ...data.id,
                fields: mappedFields,
              },
            };
            // 694387ce6806da0115bd7710
            return {
              onboardingInfo: {
                onboardingUiid: id,
                currentEditingDoc: data?._id,
                fullDoc: onboarding,
                currentChecklistId: onboarding?.checklists?.[0]?._id,
              },
              title: data?.id?.name || "-",
              initiatedDate: data?.initiatedOn
                ? dateFormator(data?.initiatedOn)
                : "-",
              dueDate: data?.dueDate ? dateFormator(data?.dueDate) : "-",
              status:
                documentOnboardingStatus?.find(
                  (doc) => doc?.value === data?.status,
                ) || "-",
              metaData: normalizedMetaData,
            };
          }) || [],
      };
      // return;
      setDrawerData(infoData);
      setIsDrawerOpen(true);
    } catch (e) {
      console.error("Error in openChecklistDrawer", e);
    }
  };
  
  //pending
  const handleJoinOnboarding = async(data,validateAllFields)=>{
    try {
      const valid = validateAllFields();
      if(!valid){
        showToast("All mandatory fields must be filled out.", "error", 5000);
        return;
      }
      if (!data.dateOfJoining) {
        showToast("Date of Joining is required", "error");
        return;
      }
      // throw new Error("Error in handleJoinOnboarding");
      const response = await updateOnboarding({
        coll: "Onboarding",
        uiid: selectedDocument?.uiid,
        payload: [
          {
            type: "SET",
            value: {
              "status": 7,
              "joiningInfo.doj":data.dateOfJoining,
            },
          },
        ],
      }); 
      if(response){
        showToast("Join Onboarding Success", "success");
        setIsJoinOnboardingDrawerOpen(false);
        childOnboardingsFetch();
      }
    }catch(e){
      console.error("Error in the handleJoinOnboarding", e)
      showToast("Join Onboarding Failed", "error");
    }
  }

  //testingh
  const applicantColumns = [
    {
      key: "name",
      label: "Name",
      render: (row) => {
        const totalDocuments =
          row?.checklists?.flatMap((doc) => doc.documents)?.length || 0;
        const statusToConsidser = 3;
        const totalDocumentsStatus =
          row?.checklists
            ?.flatMap((doc) => doc.documents)
            ?.filter((doc) => doc.status === statusToConsidser)?.length || 0;
        return (
          <div className="flex items-center gap-2">
            <Link
              className="text-linkblue cursor-pointer"
              to="/e-onboarding?e-onboarding=initiate-onboarding#initiate-onboarding"
              state={{
                onboardingCode: row?.uiid,
                entityType: row?.entity?.type,
              }}
            >
              {`${row?.entity?.id?.firstName || ""} ${row?.entity?.id?.lastName || row?.entity?.id?.businessName || ""}`}
            </Link>
            <HoverPopup
              content={
                <ul className="space-y-2">
                  {documentOnboardingStatus.map((list) => (
                    <li className="flex items-center gap-2">
                      <span
                        className={`w-2 h-2 rounded-full bg-${list.color}-500`}
                      ></span>{" "}
                      {list.label} -{" "}
                      {
                        row?.checklists
                          ?.flatMap((doc) => doc.documents)
                          .filter((doc) => doc.status === list.value).length
                      }
                    </li>
                  ))}
                  {/* <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-orange-500"></span>{" "}
                  Initiated - 7
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-orange-500"></span>{" "}
                  Responded - 1
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-500"></span>{" "}
                  Verified - 0
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-red-500"></span>{" "}
                  Rejected - 0
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-500"></span>{" "}
                  Wish To Discuss - 0
                </li>*/}
                </ul>
              }
            >
              <Chip
                label={`(${totalDocumentsStatus}/${totalDocuments})`}
                color="primary"
                size="xs"
                className="!bg-primary-100 rounded-xl !p-1"
              />
            </HoverPopup>
            <Button
              type="icon"
              variant="text"
              icon={"screen_search_desktop"}
              color="black"
              size="md"
              onClick={() => openChecklistDrawer(row, row.uiid, "applicant")}
            />
          </div>
        );
      },
    },
    {
      key: "email",
      label: "Email",
      render: (row) => row?.entity?.id?.email?.primary,
    },
    {
      key: "jobTitle",
      label: "Job Title",
      render: (row) => row?.entity?.id?.jobTitle,
    },
    {
      key: "phone",
      label: "Phone",
      render: (row) =>
        row?.entity?.id?.mobile?.primary?.code +
        row?.entity?.id?.mobile?.primary?.number,
    },
    {
      key: "joiningDate",
      label: "Joining Date",
      render: (row) => (row?.joinDate ? dateFormator(row?.joinDate) : "-"),
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <Chip
          label={
            onboardingStatus?.find((a) => a.value === row?.status)?.label || "-"
          }
          color={
            statusStyles[
              onboardingStatus?.find((a) => a.value === row?.status)?.label
            ]
          }
          className={`${statusStyles[onboardingStatus?.find((a) => a.value === row?.status)?.label]}`}
        />
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center">
          <Link
            to="/e-onboarding?e-onboarding=initiate-onboarding#initiate-onboarding"
            state={{ onboardingCode: row?.uiid, entityType: row?.entity?.type }}
          >
            <Button
              type="icon"
              variant="text"
              icon={"edit_square"}
              color="black"
              size="sm"
            />
          </Link>
          {/* <Button
            type="icon"
            variant="text"
            icon={"chat_bubble"}
            color="black"
            size="sm"
            onClick={() => setIsChatOpen(true)}
          />*/}
          <DropdownMenu
            position="left"
            MenuSection={
              <div className="flex flex-col">
                {dropdownMenuButtons.map((item) => (
                  <Button
                    title={item.label}
                    variant="text"
                    color="black"
                    size="xs-sm"
                    className="!justify-start py-2"
                    // onClick={() =>
                    //   onDropdownClick && onDropdownClick(pageName, item.label)
                    // }
                    onClick={() => {
                      item.onClick();
                      if(item.label === 'Join Onboarding'){
                        setSelectedDocument(row)
                      }
                    }}
                  />
                ))}
              </div>
            }
          >
            <Button
              icon={"more_vert"}
              variant="text"
              type="icon"
              size="sm"
              color="black"
            />
          </DropdownMenu>
        </div>
      ),
    },
  ];

  const fetchOnboardingsTable = async (
    page,
    limit,
    entityFilter,
    status,
    search,
  ) => {
    try {
      setIsLoading(true);

      const entityConfig = {
        1: {
          ref: "Employee",
          incl: ["firstName lastName email jobTitle mobile employmentType"],
        },
        2: { ref: "Entity", incl: [""] },
        3: { ref: "Entity", incl: [""] },
      };

      const { data, totalCount } = await fetchOnboardings({
        limit,
        page,
        ref: `${entityConfig[entityFilter]?.ref} Checklist PdfTemplate`,
        ret: "uiid entity documents status checklists doj",
        incl: entityConfig[entityFilter]?.incl,
        filters: {
          "entity.type": {
            type: "NONE",
            value: entityFilter,
          },
          ...(status && {
            status: { type: "NONE", value: status },
          }),
          ...(search && {
            all: {
              type: "SEARCH",
              value: search,
            },
          }),
        },
        sort: { uiid: -1 },
      });

      setOnboardingData({
        data: data?.data || [],
        totalCount: totalCount?.data || 0,
      });
    } catch (err) {
      console.error("fetchOnboardingsTable error", err);
    } finally {
      setIsLoading(false);
    }
  };

  const debouncedFetch = useMemo(
    () =>
      debounce((page, limit, entityFilter, statusFilter, searchValue) => {
        fetchOnboardingsTable(
          page,
          limit,
          entityFilter,
          statusFilter,
          searchValue,
        );
      }, 1000),
    [],
  );

  useEffect(() => {
    debouncedFetch(page, limit, entityFilter, statusFilter, searchValue);
  }, [page, limit, statusFilter, searchValue, entityFilter, debouncedFetch]);

  const childOnboardingsFetch = useCallback(() => {
    debouncedFetch(page, limit, entityFilter, statusFilter, searchValue);
  }, [page, limit, statusFilter, searchValue, entityFilter, debouncedFetch]);

  //with actual api data testing
  const mappedRows = mapTableRows(onboardingData?.data, applicantColumns);
  // //with dummydata
  // const mappedRows = mapTableRows(tableData, applicantColumns);

  const ChatMenus = [
    {
      title: "Comments",
      page: <Comments />,
      type: "main",
      value: "3",
    },
    {
      title: "Draft",
      page: <DraftChat />,
      type: "main",
    },
    {
      title: "Initiated",
      page: <InitiatedChat />,
      type: "main",
    },
    {
      title: "Responded",
      page: <RespondedChat />,
      type: "main",
    },
  ];

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };

  return (
    <>
      <div>
        <TableAdv
          columns={applicantColumns}
          rows={mappedRows}
          fixedCol={1}
          //
          serverPagination={true}
          totalCount={onboardingData?.totalCount}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          // searchConfig //
          serverSearchValue={searchValue}
          serverOnSearch={handleSearch}
          toolbarRight={{
            search: true,
            filter: true,
            add: [
              {
                component: (
                  <FormFieldSet
                    type="select"
                    noTitle
                    size="sm"
                    placeholder="Select Option"
                    options={[
                      { label: "Onboardings", value: "Onboardings" },
                      {
                        label: "Onboardings and Onboarding Documents",
                        value: "Onboardings and Onboarding Documents",
                      },
                    ]}
                    value={select}
                    onChange={setSelect}
                  />
                ),
              },
            ],
            order: ["search", "add", "filter"],
          }}
        />

        <Drawer
          isOpen={isChatOPen}
          onClose={() => setIsChatOpen(false)}
          position="right"
          width="w-[50%]"
          showCloseButton={false}
          closeOnOutsideClick
        >
          <div className="flex flex-col">
            <div className="self-end">
              <Button
                type="icon"
                icon={"close"}
                variant="text"
                color="black"
                size="sm"
                onClick={() => setIsChatOpen(false)}
              />
            </div>
            <div>
              <NewTab
                tabs={ChatMenus}
                color="black"
                variant="text"
                activeVariant="text"
              />
            </div>
          </div>
        </Drawer>
        <DashboardDrawer
          isDrawerOpen={isDrawerOpen}
          drawerData={drawerData}
          setIsDrawerOpen={() => {
            setDrawerData({});
            setIsDrawerOpen(false);
          }}
          childOnboardingsFetch={childOnboardingsFetch}
        />
        <JoinOnboardingDrawer
          isJoinOnboardingDrawerOpen={isJoinOnboardingDrawerOpen}
          setIsJoinOnboardingDrawerOpen={setIsJoinOnboardingDrawerOpen}
          handleSubmit={handleJoinOnboarding}
          onClose={() => setSelectedDocument(null)}
        />
      </div>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </>
  );
};

export default AllDashboard;
